<div class="tw-relative tw-flex tw-max-h-[116px] tw-flex-row tw-flex-wrap tw-items-center tw-justify-start">
  <div
    *ngIf="!linkedinEnabled"
    class="tw-mb-2.5 tw-mr-2.5 tw-cursor-pointer tw-rounded tw-border tw-border-[#e4e9f2] tw-bg-[#f7f9fc] tw-px-[15px] tw-py-[5px] tw-text-sm tw-font-normal tw-capitalize tw-text-[#8f9bb3] hover:tw-bg-[#edf1f7] hover:tw-text-[#536079]"
    (click)="toggleMenu()"
    role="button"
    aria-label="Add social login"
    [attr.aria-expanded]="menuOpen"
  >
    Add social login
  </div>

  <ng-container *ngIf="linkedinEnabled">
    <div
      class="tw-mb-2.5 tw-mr-2.5 tw-flex tw-items-center tw-gap-2 tw-rounded tw-border tw-border-[#e4e9f2] tw-bg-[#f7f9fc] tw-px-[15px] tw-py-[5px] tw-text-sm tw-font-normal tw-text-[#8f9bb3]"
    >
      <img src="assets/images/linkedin-icon.svg" alt="" width="16" height="16" />
      <span>LinkedIn</span>
    </div>

    <button
      type="button"
      class="tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-self-start tw-rounded-full tw-border-0 tw-bg-[#d1d7e3] tw-p-0 tw-transition hover:tw-scale-105 hover:tw-bg-[#b8c1d2]"
      (click)="toggleMenu()"
      aria-label="Edit social login"
      [attr.aria-expanded]="menuOpen"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          class="tw-fill-[#2E3138]"
          d="M0 7.00017C0 7.67684 0.548402 8.22523 1.22546 8.22523H5.77507V12.7749C5.77507 13.4518 6.32366 14.0002 7.00026 14C7.33862 14 7.64489 13.8631 7.86639 13.6415C8.08816 13.4195 8.22526 13.1134 8.22511 12.7753L8.22529 8.22505H12.7755C13.1136 8.22505 13.4196 8.08813 13.6416 7.86618C13.863 7.64478 14 7.33852 14 7.00017C14.0002 6.32361 13.4518 5.7751 12.7748 5.7751H8.22511V1.22534C8.22511 0.54857 7.6764 0 6.99974 0C6.32332 0.000182877 5.7751 0.548204 5.77474 1.22488V5.7751H1.22458C0.548036 5.77547 0.000335693 6.32361 0 7.00017Z"
        />
      </svg>
    </button>
  </ng-container>

  <div
    *ngIf="menuOpen"
    class="tw-absolute tw-left-0 tw-top-full tw-z-30 tw-mt-1 tw-flex tw-min-w-[240px] tw-flex-col tw-rounded tw-bg-white tw-pt-3 tw-shadow-[0_4px_16px_rgba(34,43,69,0.16)]"
    role="listbox"
    aria-label="Social login"
  >
    <label class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-px-3 tw-pb-2 tw-text-sm tw-text-[#222b45]">
      <input class="tw-m-0 tw-h-4 tw-w-4 tw-cursor-pointer tw-accent-[#3366ff]" type="checkbox" [checked]="draftLinkedin" (change)="setDraftLinkedIn($any($event.target).checked)" />
      <img class="tw-block tw-shrink-0" src="assets/images/linkedin-icon.svg" alt="" width="20" height="20" />
      <span>LinkedIn</span>
    </label>

    <div class="tw-sticky tw-bottom-0 tw-z-10 tw-shrink-0 tw-bg-white tw-px-2 tw-pb-2 tw-pt-2">
      <div class="tw-mb-2 tw-h-px tw-bg-[#e4e9f2]"></div>
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-end">
        <button
          type="button"
          class="tw-mr-[15px] tw-cursor-pointer tw-rounded tw-border tw-border-[#3366ff] tw-bg-transparent tw-px-3 tw-py-1 tw-text-sm tw-text-[#3366ff] hover:tw-bg-[rgba(51,102,255,0.1)]"
          (click)="applySelection()"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>
